import React from "react";
import Buttons from "../button/Buttons";
import SearchBar from "./SearchBar";
import DropdownSelect from "../dropdown/DropDrown";

function CardSection({
  children,
  cardTitle,
  rightButton,
  buttonClassName,
  titleButtonClick,
  buttonTextFront,
  hasButtonPermission,
  buttonText,
  searchInput,
  searchInputName,
  textWithIconFront,
  optionsValue,
  textWithIcon,
  iconImgFront,
  iconImg,
  handleChange,
  handleChangeDropdown,
  isLoading,
  positionFilter,
  searchFilter,
  selectedOptions,
  selectedPlaceHolder,
  secondButton,
  secondButtonClassName,
  secondTitleButtonClick,
  secondButtonTextFront,
  secondButtonText,
  secondTextWithIconFront,
  secondTextWithIcon,
  secondIconImgFront,
  secondIconImg,
  isSecondBtnLoading,
  btnTitle,
  btnTitle2,
  isMultiSelect,
  isCardSection,
  selectedOptions2,
  selectedPlaceHolder2,
  optionsValue2,
  isMultiSelect2,
  isCardSection2,
  isdropdownOpen2,
  handleChangeDropdown2,
  isdropdownOpen
}) {
  return (
    <div
      className={`card-section ${cardTitle ? "card-section-left" : ""}${searchInput && rightButton ? "card-section-between" : ""
        }${rightButton ? "card-button-only" : ""}`}
    >
      {(cardTitle || rightButton || searchInput || searchFilter || positionFilter) && (
        <div className="card-top-title-btn">
          {cardTitle && <div className="section-title">{cardTitle}</div>}
          <div className="d-flex flex-wrap align-items-center justify-content-end gap-2">
          {positionFilter  && (
              <div className="filter-select ml-2 mr-2">
                <DropdownSelect
                  value={selectedOptions2}
                  options={optionsValue2}
                  isMultiSelect={isMultiSelect2}
                  onChange={handleChangeDropdown2}
                  isCardSection={isCardSection2}
                  isdropdownOpen={isdropdownOpen2}
                  placeholder={selectedPlaceHolder}
                />
              </div>
            )}

            {searchInput && (
              <div className="search-input">
                <SearchBar
                  searchText={searchInputName}
                  handleChange={handleChange}
                />
              </div>
            )}
            {searchFilter && (
              <div className="filter-select ml-2">
                <DropdownSelect
                  value={selectedOptions}
                  options={optionsValue}
                  isMultiSelect={isMultiSelect}
                  onChange={handleChangeDropdown}
                  isCardSection={isCardSection}
                  isdropdownOpen={isdropdownOpen}
                  placeholder={selectedPlaceHolder2}
                />
              </div>
            )}

            {hasButtonPermission && (
              <>
                {rightButton && (
                  <div className="btn-right-sec ml-4">
                    {/* Button to open the Add Craft modal */}
                    <Buttons
                      btnTitle={btnTitle2}
                      buttonTypeClassName={buttonClassName}
                      onClick={titleButtonClick}
                      buttonTextFront={buttonTextFront}
                      buttonText={buttonText}
                      textWithIconFront={textWithIconFront}
                      textWithIcon={textWithIcon}
                      imagePathFront={iconImgFront}
                      imagePath={iconImg}
                      isLoading={isLoading}
                    />
                  </div>
                )}

                {secondButton && (
                  <div className="btn-right-sec ml-4">
                    {/* Button to open the Add Craft modal */}
                    <Buttons
                      btnTitle={btnTitle}
                      buttonTypeClassName={secondButtonClassName}
                      onClick={secondTitleButtonClick}
                      buttonTextFront={secondButtonTextFront}
                      buttonText={secondButtonText}
                      textWithIconFront={secondTextWithIconFront}
                      textWithIcon={secondTextWithIcon}
                      imagePathFront={secondIconImgFront}
                      imagePath={secondIconImg}
                      isLoading={isSecondBtnLoading}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
      <div className="card-body-sec mt-2">{children}</div>
    </div>
  );
}

export default CardSection;
